import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'chartjsMixin',
  props: {
    dashboardMetric: {
      type: Object
    }
  },
  methods: {
    renderColumn (colConfig, item) {
      return Configuration.datatable.renderColumn(colConfig, item)
    },
    addColors (amount) {
      const colors = []
      const predefinedColors = ['orange', 'purple', 'lightblue', 'brown', 'darkgreen', 'pink']

      if (amount <= predefinedColors.length) {
        for (let i = 0; i < amount; i++) {
          colors.push(predefinedColors[i])
        }
      } else {
        for (let i = 0; i < amount; i++) {
          const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16).toUpperCase()
          colors.push(randomColor)
        }
      }
      return colors
    }
  }
}
